<h1 mat-dialog-title>{{ data.title || 'Configuration' }}</h1>
<div mat-dialog-content class="view-body">
  <div class="meta-grid">
    <div><span class="label">Status</span>{{ data.status || '--' }}</div>
    <div><span class="label">Maker</span>{{ data.makerEmail || '--' }}</div>
    <div><span class="label">Checker</span>{{ data.checkerEmail }}</div>
    <div><span class="label">Submitted</span>{{ data.createdAt || '--' }}</div>
    <div><span class="label">Updated</span>{{ data.updatedAt || '--' }}</div>
  </div>
  <p class="remark" *ngIf="data.remark"><span class="label">Remark</span>{{ data.remark }}</p>

  <h3>Payload {{ isPending ? '(applies after approval)' : '' }}</h3>
  <table class="config-table" *ngIf="fields.length">
    <tr *ngFor="let field of fields">
      <td class="key">{{ field.key }}</td>
      <td class="value">{{ field.value }}</td>
    </tr>
  </table>
  <p *ngIf="!fields.length">No payload</p>

  <div class="decide-box" *ngIf="data.showDecision">
    <p class="own-request" *ngIf="isMakerWithdraw">You can withdraw this request by rejecting it.</p>
    <ng-container *ngIf="canApprove || canReject">
      <label class="label" for="reviewRemark">Remark (optional)</label>
      <textarea id="reviewRemark" class="remark-input" rows="2" [(ngModel)]="reviewRemark"
        placeholder="Add a remark"></textarea>
    </ng-container>
  </div>
</div>
<mat-dialog-actions class="dialog-actions">
  <button class="btn btn-cancel" (click)="close()">Close</button>
  <button class="btn btn-reject" *ngIf="showDecision && canReject" (click)="reject()">Reject</button>
  <button class="btn btn-approve" *ngIf="showDecision && canApprove" [disabled]="!canApprove" (click)="approve()">Approve</button>
</mat-dialog-actions>
